<template>
  <div class="email-box">
    <span class="email-box__title">{{ title }}</span>
    <a :href="`mailto:${email}`" class="email-box__email">{{ email }}</a>
  </div>
</template>
<script>
export default {
  name: "EmailBox",
  props: {
    title: {
      type: String,
      default: undefined
    },
    email: {
      type: String,
      default: undefined
    }
  }
};
</script>

<style lang="scss" scoped>
.email-box {
  display: flex;
  flex-direction: column;
  color: theme-color("body");
  font-size: px-to-rem(18px);
  font-weight: 700;

  @include if-tablet {
    font-size: px-to-rem(20px);
  }

  &__title {
    margin-bottom: spacer("s");
  }

  &__email {
    display: inline-block;
    color: theme-color("body");
    transition: cta-transition(color, 0.3s);

    &:hover {
      color: lighten(theme-color("accent-3"), 10%);
    }
  }
}
</style>
